

const SERVICES = {
  dashboard: {
    title: 'navbar.Tree.Dashboard.Title',
    link: '/',
    options: {
    },
    isActive: (currentPath) => {
      return currentPath === '/' || currentPath.startsWith('/dashboard');
    },
  },
  schedule: {
    title: 'navbar.Tree.Schedule.Title',
    link: '/events',
    options: {
    },
    isActive: (currentPath) => {
      return currentPath.startsWith('/events');
    },
  },
  caregivers: {
    title: 'navbar.Tree.Caregivers.Title',
    link: '/caregivers',
    options: {
    },
    isActive: (currentPath) => {
      return currentPath.startsWith('/caregivers');
    },
  },
};

export default SERVICES;
